// extracted by mini-css-extract-plugin
export default {"packageLabelContainer":"phtB1Xf2FDJB39pmDi5H","packageLabelText":"PAxAlV0otah5Lr5R0GOB","packageLabelOptionsSelect":"Pp355gaV8phtYi0xKKPK"};